import React, {Component, ReactNode} from 'react'
import styled from 'styled-components'
import {Nullable} from '../../../app/TypeHelpers'
import {LOGIN_MODE} from '../../../CodeMaster'
import MessageDialogComponent from '../../../common/resident/MessageDialogComponent'
import {Messages} from '../../../Messages'
import {NavigateFunction} from 'react-router-dom'
import {isWidthDown, WithWidth, WithWidthProps} from '../../../components/shared/forms/hoc/withMediaQuery'

interface Props {
    loginMode: Nullable<string>
    navigate: NavigateFunction
    sutekiNetPlusUrlPc: string
    sutekiNetPlusUrlSp: string
    showSmileagePointArea: boolean
}

interface State {
    openOperationNotAvailableToAdminDialog: boolean
}

class NatSutekiNetPlusComponent extends Component<Props & WithWidthProps, State> {

    constructor(props: Readonly<Props & WithWidthProps>) {
        super(props)

        this.state = {
            openOperationNotAvailableToAdminDialog: false,
        }
    }

    // 管理者操作不可のダイアログを閉じる
    handleCloseOperationNotAvailableToAdminDialog = () => {
        this.setState({openOperationNotAvailableToAdminDialog: false})
    }

    private adminBannerClick = () => {
        this.setState({openOperationNotAvailableToAdminDialog: true})
    }

    private renderSutekiNetPlus(): ReactNode {
        const {
            sutekiNetPlusUrlSp,
            sutekiNetPlusUrlPc,
        } = this.props
        const showSmileagePointArea = this.props.showSmileagePointArea

        if (!sutekiNetPlusUrlPc || !sutekiNetPlusUrlSp) {
            return;
        }
        const width = this.props.width;
        const spMode = isWidthDown(width, true)
        const banner = spMode
            ? {
                imageWidth: showSmileagePointArea ? 112 : '100%',
                url: sutekiNetPlusUrlSp,
                imageSrc: showSmileagePointArea
                    ? '/resources/images/mypage/bnr_224_120_2.png'
                    : '/resources/images/mypage/bnr_520_120_1.png',
                paddingBottom: showSmileagePointArea ? undefined : '30px',
                imageHeight: showSmileagePointArea ? 60 : 'auto'
            }
            : {
                imageWidth: 260,
                url: sutekiNetPlusUrlPc,
                imageSrc: '/resources/images/mypage/bnr_520_120_1.png',
            }

        const sutekiNetPlusClick = () => {
            if (this.props.loginMode === LOGIN_MODE.ADMIN.value) {
                this.adminBannerClick();
                return;
            }
           window.open(banner.url, '_blank')
        }

        return (
            <>
                <div
                    onClick={sutekiNetPlusClick}
                    style={{
                        width: banner.imageWidth,
                        height: 60,
                        display: 'block',
                        objectFit: 'contain',
                        cursor: 'pointer',
                        paddingBottom: banner.paddingBottom
                    }}
                >
                    <SutekiNetPlusBannerImage
                        src={banner.imageSrc}
                        alt={'素敵ネットプラスバナー'}
                        style={{
                            width: banner.imageWidth,
                            height: banner.imageHeight,
                            display: 'block',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            </>
        )
    }

    private renderOperationNotAvailableToAdminDialog(): ReactNode {
        return (
            <MessageDialogComponent
                open={this.state.openOperationNotAvailableToAdminDialog}
                params={{
                    title: '確認',
                    errorLevel: Messages.ISYCR0001.errorLevel,
                    message: Messages.ISYCR0001.toString(),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleCloseOperationNotAvailableToAdminDialog,
                        },
                    ],
                }}
            />
        )
    }

    render(): ReactNode {
        let sutekiNetPlusComponent: ReactNode

            sutekiNetPlusComponent = this.renderSutekiNetPlus()

        return <>
                {sutekiNetPlusComponent}
                {this.renderOperationNotAvailableToAdminDialog()}
        </>
    }
}

export default WithWidth(NatSutekiNetPlusComponent)

const SutekiNetPlusBannerImage = styled.img`
    border-radius: 4px;
    box-shadow: 0px 3px 3px darkgray;
`
